
<template>
    <modal name="usStatusFieldsUpdateModal" classes="v-modal-sec" :min-width="200" :min-height="200"
    :scrollable="true" :reset="true"  width="750px"  height="auto">
    <div class="v-modal profile_details_modal error-modal-space">
        <div class="popup-header fromDetailsPage">
            <h2 class="popup-title">Status Fields</h2>
            <span  @click="hideMe()"><em class="material-icons">close</em></span>
        </div>
        <form @submit.prevent data-vv-scope="usStatusfieldsUpdateForm">
            <div class="form-container">
                <div class="vx-row" @click="errorMsg = ''">
                    <immiInput :onlyNumbers="true" :allowFloatingPoint="false" :maxLength="8" :display="false" :fieldsArray="[]"  :cid="'curNonImmigrantVisaNumber'" formscope="usStatusfieldsUpdateForm" v-model="usStausObj.curNonImmigrantVisaNumber" :fieldName="'curNonImmigrantVisaNumber'"  :required="true"  label="Current Non-Immigrant Visa Number" placeHolder="Current Non-Immigrant Visa Number" />
                    <selectField :display="false" :fieldsArray="[]" @input="usStausObj.curNonImmigrantVisaStatus = usStausObj.curNonImmigrantVisaStatusDetails.id;checkDSExpireFields()" :required="true" :optionslist="visaStatusList" v-model="usStausObj.curNonImmigrantVisaStatusDetails" :fieldName="'curNonImmigrantVisaStatus'"  formscope="usStatusfieldsUpdateForm"  label="Current Non-Immigrant Status" vvas="Current Non-Immigrant Status" placeholder="Current Non-Immigrant Status" />
                    <div class="vx-col w-full md:w-1/2 relative" v-if="(checkProperty(usStausObj,'curNonImmigrantVisaStatusDetails')&& checkProperty(usStausObj,'curNonImmigrantVisaStatusDetails','id'))">
                        <div class="vs-col w-1/2 ds_check" v-if="checkProperty(usStausObj,'curNonImmigrantVisaStatusDetails')&& checkProperty(usStausObj,'curNonImmigrantVisaStatusDetails','id')  "  >
                            <div class="form_group custom-form-label custom-cx-box">
                                <vs-checkbox v-model="usStausObj.isDSExpiryDate" :fieldName="'consularProcessing'"  data-vv-as="consularProcessing"  name="isDSExpiryDate" @input="clearCurrentStatusField"
                                >Check here if D/S
                                </vs-checkbox>
                            </div>
                        </div>
                        <datepickerField :wrapclass="'md:w-full'" :isDisabled=" usStausObj.isDSExpiryDate|| !usStausObj.curNonImmigrantVisaStatus" 
                        :display="false" :notRequired="usStausObj.isDSExpiryDate " :tplkey="'curVisaExpiryDate'" :fieldsArray="[]" :dateEnableFrom="new Date()" :validationRequired="true" v-model="usStausObj.curVisaExpiryDate" :fieldName="'curVisaExpiryDate'"  formscope="usStatusfieldsUpdateForm"  label="Current Status Expiry Date" />
                    </div>
                </div>
                <div v-show="errorMsg">
                    <vs-alert
                    color="warning"
                    class="warning-alert reg-warning-alert no-border-radius"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                    >{{ errorMsg }}</vs-alert
                    >
                </div>
            </div>
            <div class="popup-footer relative">
                <span class="loader" v-if="loading" ><img src="@/assets/images/main/loader.gif"/></span>
                <vs-button color="dark"  @click="hideMe()"  class="cancel" type="filled">Cancel</vs-button>
                <vs-button  color="success"  :disabled="loading"  @click="submitForm()" class="save" type="filled">Update </vs-button>
            </div>
        </form>
    </div>
    </modal>
  </template>
  <script>
  import datepickerField from "@/views/forms/fields/datepicker.vue";
  import selectField from "@/views/forms/fields/simpleselect.vue";
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import moment from "moment";
  //import FileUpload from "vue-upload-component/src";
  import { EyeIcon } from 'vue-feather-icons'
  import docType from "@/views/common/docType.vue"
  import fileUploadNote from "@/views/common/fileUploadNote.vue";
  import FileUpload from "@/views/FileUpload.vue";
  
  export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components: {
        datepickerField,
        selectField,
        immiInput,
        docType,
        EyeIcon,
        FileUpload,
        fileUploadNote
    },
    methods: {
        hideMe() {
            this.$emit("hideMe");
            this.$modal.hide("usStatusFieldsUpdateModal");
        },
        submitForm(){
            this.$validator.validateAll("usStatusfieldsUpdateForm").then((result) => {
                if(result){

                }
            })
        },
        clearCurrentStatusField(val){
            if(val){
                this.usStausObj.curVisaExpiryDate = null;
            }
        },
        checkDSExpireFields(){
            if(this.checkProperty(this.usStausObj,'curNonImmigrantVisaStatusDetails') && !this.checkProperty(this.usStausObj,'curNonImmigrantVisaStatusDetails','id') ){
                this.usStausObj.isDSExpiryDate = false;
            }
        },
     
    },
    watch: {
      
    },
    mounted() {
        this.$store.dispatch("getmasterdata", "visa_status").then((response) => {
            this.visaStatusList = response;
        });
      this.$modal.show("usStatusFieldsUpdateModal");
  
    },
    data: () => ({
        visaStatusList:[],
        loading:false,
        errorMsg:'',
        usStausObj:{
            curNonImmigrantVisaNumber:null,
            curVisaExpiryDate:null,
            isDSExpiryDate:null,
            curNonImmigrantVisaStatus:null,
            curNonImmigrantVisaStatusDetails:null,
        }
    }),
    props: {
      petitionDetails: {
        type: Object,
        default: null,
      },
    },
  };
  </script>